var o;!function(o){o.ClimateSource="DCS",o.PowerSolutions="DPS",o.Semikron="SDW"}(o||(o={}));export{o as AppBusinessSegmentEnum};
